@if (isTrue) {
<icon type="check2" matTooltip="Yes"></icon>
} @if (!isTrue) {
<icon type="x" matTooltip="No"></icon>
}
